import queryString from 'query-string';
import {Component, Vue} from '../Annotation';

@Component
export default class QueryString extends Vue {

	/**
	 * return query router as plain js object
	 *
	 * current limitation !!! window.location.search cannot reactive
	 * to the template!!
	 */
	public get routeQuery() {
		return this.hasVueRouter ? this.$route.query : (window.location.search ? queryString.parse(window.location.search) : {});
	}

	public get hasVueRouter() {
		return this.$route && this.$router;
	}

	// match given url with location.pathname and location.search
	public matchAbsoluteUrl(link: string) {
		return this.hasVueRouter ? this.$route.fullPath === link : link === location.pathname + location.search;
	}
}
